import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
/**
 * GameStyle.ts
 */
export class GameStyle extends SlingoStyle {
}
GameStyle.GRID_BORDER_OVERLAY = "GridBorderOverlay";
GameStyle.WIN_LINE_BORDER = "WinBorder";
GameStyle.COCONUT_BACKGROUND = "BonusBackground";
GameStyle.COCONUT_TITLE = "BonusTitle";
GameStyle.COCONUT = "BonusObject";
GameStyle.PAY_LADDER = "PayLadder";
GameStyle.MINI_PAY_LADDER = "MiniPayLadder";
GameStyle.SUMMARY_PANEL = "SummaryPanel";
GameStyle.SUMMARY_BACKGROUND = "WinDisplay";
GameStyle.CHANCE_GAME_PANEL = "ScatterWinPanel";
GameStyle.WIN_LINE_PANEL = "LineWinPanel";
GameStyle.SPINS_COUNTER_ANIMATION = "SpinsCounter";
GameStyle.SCATTER = "B";
GameStyle.DAB_TRAIL_SHORT = "DabTrailShort";
GameStyle.DAB_TRAIL_MEDIUM = "DabTrailMedium";
GameStyle.DAB_TRAIL_LONG = "DabTrailLong";
GameStyle.FIREWORK_TRAIL = "FireworkTrail";
GameStyle.FIREWORK_SYMBOL = "ExplodingFruit";
GameStyle.REEL_SYMBOL_WILD = "ReelSymbolWild";
GameStyle.REEL_SYMBOL_SUPER_WILD = "ReelSymbolSuperWild";
GameStyle.REEL_SYMBOL_FREE_SPIN = "ReelSymbolFreeSpins";
GameStyle.REEL_SYMBOL_BLOCKER = "ReelSymbolBlocker";
GameStyle.REEL_SYMBOL = "ReelSymbol";
GameStyle.REEL_SUSPENSE_ANIMATION = "TensionSpin";
GameStyle.FREE_SPIN_TRAIL_GLOW = {
    distance: 20,
    strength: 5,
    colours: [
        0xb03d98,
        0xdf6f3c,
        0xf4ab20,
        0x6db300,
        0x0596b9
    ]
};
GameStyle.WIN_FANCY = "win";
GameStyle.BIG_WIN_FANCY = "bigwin";
GameStyle.EPIC_WIN_FANCY = "epicwin";
GameStyle.MEGA_WIN_FANCY = "megawin";
GameStyle.FULL_HOUSE_FANCY = "fullhouse";
GameStyle.MINI_FANCY = "mini";
GameStyle.MINOR_FANCY = "minor";
GameStyle.MAJOR_FANCY = "major";
GameStyle.DIALOG_BUTTON_RED = "red-DialogButton0";
GameStyle.DIALOG_BUTTON_GREEN = "green-DialogButton0";
GameStyle.DIALOG_BUTTON_BLUE_BIG = "double-DialogButton0";
//# sourceMappingURL=GameStyle.js.map